import PCancelable from 'cancelable-promise'
import React from 'react'
import { Helmet } from 'react-helmet'
import api from '../api/services'
import Button from '../components/Button'
import Field from '../components/Field'
import Pell from '../components/Pell'
import useNotifications from '../hooks/notifications'
import getReservationSettings from '../settings/reservations'
import getRidingSchoolSettings from '../settings/ridingschool'
import getTemplateSettings from '../settings/templates'
import state from '../state'
import { getFormData } from '../utils/data'

const Settings = () => {
  const statusOpts = getReservationSettings().fields.find(
    (f) => f.name === 'status'
  )

  statusOpts.options = [
    ...statusOpts.options,
    ...getRidingSchoolSettings().fields.find((f) => f.name === 'status').options
  ]

  const { getLabel } = getTemplateSettings()

  const { addNotification } = useNotifications()

  const [templateBody, setTemplateBody] = React.useState('')
  const [template, setTemplate] = React.useState({})
  const [type, setType] = React.useState(statusOpts.options[0])

  const handleSubmit = (e) => {
    e.preventDefault()

    const data = {
      ...getFormData(e.target),
      body: templateBody
    }

    if (template._id) {
      return api.templates.patch(template._id, data).then(
        ({ status }) =>
          addNotification({
            payload: `${getLabel(status)} wurde erfolgreich gespeichert`,
            type: 'success'
          }),
        addNotification
      )
    }

    api.templates.create(data).then(
      ({ status }) =>
        addNotification({
          payload: `${getLabel(status)} wurde erfolgreich angelegt`,
          type: 'success'
        }),
      addNotification
    )
  }

  React.useEffect(() => {
    state.semaphore++

    const p = new PCancelable((resolve, reject) => {
      api.templates
        .find({ query: { status: type, $limit: 1 } })
        .then(resolve, reject)
    })

    p.then(([template = {}]) => {
      setTemplate(template)
      state.semaphore--
    }).catch(addNotification)

    return () => p.cancel()
  }, [addNotification, type])

  return (
    <div>
      <Helmet>
        <title>
          {window.document.head.dataset.titlePrefix} | Einstellungen
        </title>
      </Helmet>

      <h1 className="mb-6 text-3xl">Einstellungen</h1>

      <form onSubmit={handleSubmit}>
        <fieldset className="mb-8 rounded border px-6 py-2 shadow sm:w-full">
          <legend className="-mx-2 bg-white px-2 text-blue-700 uppercase">
            E-Mail-Bestätigungen
          </legend>

          <div className="-m-2 flex flex-wrap justify-end">
            <div className="w-full p-2 md:w-1/4">
              <Field
                {...statusOpts}
                onChange={({ target: { value } }) => setType(value)}
                required={undefined}
                value={type}
              />
            </div>

            <div className="w-full p-2 md:w-3/4">
              <Field
                defaultValue={template.subject}
                label="Betreff"
                name="subject"
                type="text"
              />
            </div>

            <div className="w-full p-2 md:w-1/4">
              <Field
                defaultChecked={template.active}
                label="Aktiv"
                name="active"
                type="checkbox"
              />
            </div>

            <div className="w-full p-2 md:w-3/4">
              <label className="block font-bold text-gray-700 text-sm">
                Text
              </label>
              <Pell
                initialContent={template.body}
                handleChange={setTemplateBody}
              />
            </div>

            <div className="p-2">
              <Button color="primary" type="submit">
                Speichern
              </Button>
            </div>
          </div>
        </fieldset>
      </form>
    </div>
  )
}

export default Settings
